import React from "react";
import { Switch, Route } from 'react-router';

//dev
import SaveAnswer from '../views/externalexpert/answer';
import SatisfactionMeter from '../views/satisfaction/answer';

const Public = ({ match }) =>{
	console.log('public=', match);
	let ws = '/s/objsrv';
	let lws = location.pathname.split('/')[2];
	if( lws !== 'undefined'){
		ws = '/s/'+lws
	}
	switch( match.path ){
		case "/":
		case "/externalexpert/answer/**":
			return(<SaveAnswer wspace={ws} />);
		case "/satisfaction/meter/answer/**/**":
			return <SatisfactionMeter wspace={ws} url={match.url} preview={false} />
		case "/satisfaction/preview/meter/answer/**/**":
			return <SatisfactionMeter wspace={ws} url={match.url} preview={true} />
		default:
			return <NotFoundPage />;
	}
}
class NotFoundPage extends React.Component {
	render() {
		return (
			<div className="not-found">
				<h1>404</h1>
				<h2>Page not found!</h2>
				<p>
					<a href="#new">Go back to the main page</a>
				</p>
			</div>
		);
	}
}
const Routes = () => (
	<Switch>
		<Route exact path="/" component={Public}/>
		<Route exact path="/externalexpert/answer/**" component={Public}/>
		<Route exact path="/satisfaction/meter/answer/**/**" component={Public}/>
		<Route exact path="/satisfaction/preview/meter/answer/**/**" component={Public}/>
	</Switch>
);
export default Routes;
